import { useValidationsField } from '@insurance/hooks'

import { InsuranceRcaMainStep } from '../InsuranceRcaMainStep'

export const MainStep = () => {
  const { certificateNumberRCA } = useValidationsField()

  return <InsuranceRcaMainStep certificateValidator={certificateNumberRCA} />
}
